<div class="edit-commission-detail-dialog">
  <div class="edit-commission-detail-dialog-header flex-between-center">
    <div class="flex-start-center m-0">
      <i class="fas fa-envelope-open-dollar font-primary commission-header-icon mr-2"></i>
      <div class="flex-column">
        <span class="font-bold font-18">Edit Commissions - {{employeeName}}</span>
        <span class="font-14">RO# {{orderCode}}</span>
      </div>
    </div>

    <div class="flex-end-center">
      <span class="close-modal">
        <i class="fal fa-times" (click)="handleClose()"></i>
      </span>
    </div>
  </div>

  <div class="edit-commission-detail-dialog-body">
    <div class="edit-commission-detail-container flex-start-start">
      <!-- Commission Metric -->
      <div class="commission-metrics flex-column">
        <!-- Total commission -->
        <p class="flex-start-center mb-0 total-commission">
          <span class="font-600 total-commission-width">Total Commission</span>
          <span class="font-600">{{totalCommission || 0 | currency: usd}}</span>
        </p>

        <!-- Invoice commission -->
        <div *ngIf="invoiceCommissions?.length" class="flex-column commission-table invoice-commission mt-4">
          <p class="mb-0 flex-between-center commission-table-main">
            <span class="font-600">Invoice gross profit</span>
            <span class="font-600"></span>
          </p>

          <div class="flex-start-center commission-table-header">
            <div class="commission-base font-600 flex-start-start">Commission base</div>
            <div class="commission-amount font-600 flex-start-start">Commissionable amount</div>
            <div class="commission-earned font-600 flex-start-start">Commission earned</div>
          </div>

          <div class="commission-table-body">
            <div *ngFor="let row of invoiceCommissions" class="flex-start-center table-row">
              <div class="commission-base">Profit: {{row?.commission?.detail.split(" ")[1]}}</div>

              <div class="commission-amount flex-start-center">
                <span class="pr-2">{{row?.commissionableAmount}}</span>
              </div>

              <div class="commission-earned position-relative">
                <app-input class="width-80px" placeholder="0" styleClassInput="pl-0" styleClass="pl-2 bg-color-white"
                  [theme]="commissionInputFocus['invoice-metric']? 'primary' : 'light'" [fontSize]="14"
                  [selectTextOnFocus]="true" [allowDecimal]="commissionInputFocus['invoice-metric']" [value]="commissionInputFocus['invoice-metric'] ?
                  commissionChange['invoice-metric']
                  :
                  (commissionChange['invoice-metric'] | currency: usd)" (appFocus)="handleFocus('invoice', 'metric')"
                  (appBlur)="handleBlur('invoice', 'metric')" (appKeyUp)="handleChange('invoice', 'metric', $event)">
                </app-input>

                <span *ngIf="isCommissionUpdate(commissionChange['invoice-metric'], row?.actualCommissionEarned)"
                  class="commission-undo">
                  <i class="fal fa-undo font-primary font-bold pointer" tooltipPosition="top" [escape]="false"
                    [pTooltip]="row?.commissionTooltip"
                    (click)="handleUndoCommission('invoice', 'metric', row?.actualCommissionEarned)"></i>
                </span>
              </div>
            </div>
          </div>
        </div>

        <!-- Labor commission -->
        <div *ngIf="laborCommissions?.length" class="flex-column commission-table mt-4">
          <p class="mb-0 flex-start-center commission-table-main">
            <span class="font-600 item-text-width">Labor items</span>
            <span class="font-400">Total: {{totalLaborCommission || 0 | currency: usd}}</span>
          </p>

          <div class="flex-start-center commission-table-header">
            <div class="service font-600 flex-start-start">Service</div>
            <div class="item font-600 flex-start-start">Item</div>
            <div class="commission-base font-600 flex-start-start">Commission base</div>
            <div class="commission-amount font-600 flex-start-start">Commissionable amount</div>
            <div class="commission-earned font-600 flex-start-start">Commission earned</div>
          </div>

          <div class="commission-table-body">
            <div *ngFor="let row of laborCommissions" class="flex-start-center table-row">
              <div class="service">{{row?.service?.title}}</div>

              <div class="item">{{row?.item?.title}}</div>

              <div class="commission-base">Profit: {{row?.commission?.detail.split(" ")[1]}}</div>

              <div class="commission-amount flex-start-center">
                <span class="pr-2">{{row?.commissionableAmount || 0 | currency: usd}}</span>
                <i class="fal fa-info-circle text-dark" tooltipStyleClass="commission-dist-tooltip" [pTooltip]="row?.tooltip"
                  [escape]="false"></i>
              </div>

              <div class="commission-earned position-relative">
                <app-input class="width-80px" placeholder="0" styleClassInput="pl-0" styleClass="pl-2 bg-color-white"
                  [theme]="commissionInputFocus[row?.service?.orderServiceId + '-' + row?.item?.orderItemId]? 'primary' : 'light'"
                  [fontSize]="14" [selectTextOnFocus]="true"
                  [allowDecimal]="commissionInputFocus[row?.service?.orderServiceId + '-' + row?.item?.orderItemId]"
                  [value]="commissionInputFocus[row?.service?.orderServiceId + '-' + row?.item?.orderItemId] ?
                  commissionChange[row?.service?.orderServiceId + '-' + row?.item?.orderItemId]
                  :
                  (commissionChange[row?.service?.orderServiceId + '-' + row?.item?.orderItemId] | currency: usd)"
                  (appFocus)="handleFocus(row?.service?.orderServiceId, row?.item?.orderItemId)"
                  (appBlur)="handleBlur(row?.service?.orderServiceId, row?.item?.orderItemId)"
                  (appKeyUp)="handleChange(row?.service?.orderServiceId, row?.item?.orderItemId, $event)">
                </app-input>

                <span
                  *ngIf="isCommissionUpdate(commissionChange[row?.service?.orderServiceId + '-' + row?.item?.orderItemId], row?.actualCommissionEarned)"
                  class="commission-undo">
                  <i class="fal fa-undo font-primary font-bold pointer" tooltipPosition="top" [escape]="false"
                    [pTooltip]="row?.commissionTooltip"
                    (click)="handleUndoCommission(row?.service?.orderServiceId, row?.item?.orderItemId, row?.actualCommissionEarned)"></i>
                </span>
              </div>
            </div>
          </div>
        </div>

        <!-- Non-labor commission -->
        <div *ngIf="nonLaborCommissions?.length" class="flex-column commission-table mt-4">
          <p class="mb-0 flex-start-center commission-table-main">
            <span class="font-600 item-text-width">Non-labor items</span>
            <span class="font-400">Total: {{totalNonLaborCommission || 0 | currency: usd}}</span>
          </p>

          <div class="flex-start-center commission-table-header">
            <div class="service font-600 flex-start-start">Service</div>
            <div class="item font-600 flex-start-start">Item</div>
            <div class="commission-base font-600 flex-start-start">Commission base</div>
            <div class="commission-amount font-600 flex-start-start">Commissionable amount</div>
            <div class="commission-earned font-600 flex-start-start">Commission earned</div>
          </div>

          <div class="commission-table-body">
            <div *ngFor="let row of nonLaborCommissions" class="flex-start-center table-row">
              <div class="service">{{row?.service?.title}}</div>

              <div class="item">{{row?.item?.title}}</div>

              <div class="commission-base">Profit: {{row?.commission?.detail.split(" ")[1]}}</div>

              <div class="commission-amount flex-start-center">
                <span class="pr-2">{{row?.commissionableAmount || 0 | currency: usd}}</span>
                <i class="fal fa-info-circle text-dark" tooltipStyleClass="commission-dist-tooltip" [pTooltip]="row?.tooltip"
                  [escape]="false"></i>
              </div>

              <div class="commission-earned position-relative">
                <app-input class="width-80px" placeholder="0" styleClassInput="pl-0" styleClass="pl-2 bg-color-white"
                  [theme]="commissionInputFocus[row?.service?.orderServiceId + '-' + row?.item?.orderItemId]? 'primary' : 'light'"
                  [fontSize]="14" [selectTextOnFocus]="true"
                  [allowDecimal]="commissionInputFocus[row?.service?.orderServiceId + '-' + row?.item?.orderItemId]"
                  [value]="commissionInputFocus[row?.service?.orderServiceId + '-' + row?.item?.orderItemId] ?
                  commissionChange[row?.service?.orderServiceId + '-' + row?.item?.orderItemId]
                  :
                  (commissionChange[row?.service?.orderServiceId + '-' + row?.item?.orderItemId] | currency: usd)"
                  (appFocus)="handleFocus(row?.service?.orderServiceId, row?.item?.orderItemId)"
                  (appBlur)="handleBlur(row?.service?.orderServiceId, row?.item?.orderItemId)"
                  (appKeyUp)="handleChange(row?.service?.orderServiceId, row?.item?.orderItemId, $event)">
                </app-input>

                <span
                  *ngIf="isCommissionUpdate(commissionChange[row?.service?.orderServiceId + '-' + row?.item?.orderItemId], row?.actualCommissionEarned)"
                  class="commission-undo">
                  <i class="fal fa-undo font-primary font-bold pointer" tooltipPosition="top" [escape]="false"
                    [pTooltip]="row?.commissionTooltip"
                    (click)="handleUndoCommission(row?.service?.orderServiceId, row?.item?.orderItemId, row?.actualCommissionEarned)"></i>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Activity Log -->
      <div class="commission-activity mb-3">
        <p class="font-bold mb-4 mt-3 ml-3">Activity logs</p>

        <div *ngIf="activityLogs?.length" class="position-relative">
          <div class="activity-divider"></div>
          <div class="activity-circle"></div>
          <ng-container *ngFor="let activity of activityLogs">
            <div class="commission-plan-activity flex-start-start width-100p mb-3 position-relative">
              <div class="activity-icon-wrapper flex-center-center">
                <div class="activity-icon flex-center-center text-transform-uppercase core-activity">
                  <span class="font-16 font-800 activity-icon-name-initilas">{{activity?.data?.initials}}</span>
                </div>
              </div>

              <div class="activity-overview flex-column">
                <p class="m-0 font-gray-35 font-10">
                  {{getTime(activity?.createdAt)}}
                </p>

                <div class="flex-start">
                  <p class="m-0" [ngClass]="{'text-truncate': isAllPlanLogs}" [innerHTML]="activity?.text"></p>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>

  </div>

  <div class="edit-commission-detail-dialog-footer flex-end-center">
    <button class="btn btn-border pointer btn-submit mr-1" (click)="handleClose(false)">
      Cancel
    </button>

    <button class="btn btn-primary btn-submit" [disabled]="isProcessing || isSyncing" (click)="handleSubmit()">
      Save
      <i class="fal fa-spinner rotate" *ngIf="isProcessing"></i>
    </button>
  </div>
</div>
